import React from "react";
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

import { useDownloadRpmListMutation } from "app/store/patient/api/patientApi";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import { Formik } from "formik";
import { lateRPMValidationSchema } from "schemas/lateRPMValidationSchema";
import SubmitButton from "components/Button/SubmitButton";
import LoadingModal from "components/common/loading/LoadingModal";

const LateRPMPatient = ({
  role,
  accounts,
  lateRpmModalOpen,
  closeLateRpmModal,
}) => {
  const [downloadRpmList] = useDownloadRpmListMutation();

  const onClose = () => {
    closeLateRpmModal();
  };

  return (
    <ModalWrapper
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      show={lateRpmModalOpen}
      onClose={onClose}
      title="Late RPM List"
    >
      <Formik
        initialValues={{
          account: accounts?.length === 1 ? accounts?.[0]?.name : "",
        }}
        validationSchema={lateRPMValidationSchema}
        onSubmit={(values) => downloadRpmList(values.account)}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors,
          isSubmitting,
          resetForm,
        }) => (
          <>
            <div style={{ marginBottom: "20px", marginTop: "20px" }}>
              <FormControl
                variant="outlined"
                style={{ width: "100%" }}
                error={touched.account && Boolean(errors.account)}
              >
                <InputLabel id="issue-label">Select Account</InputLabel>
                <Select
                  id="accounts"
                  value={
                    accounts?.length > 1 ? values.account : accounts?.[0]?.name
                  }
                  onChange={handleChange("account")}
                  disabled={accounts?.length <= 1 || role === "clinic"}
                  label="Select Account"
                >
                  {accounts?.map(({ name }, index) => (
                    <MenuItem key={index} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {touched.account && errors.account && (
                <FormHelperText error>{errors.account}</FormHelperText>
              )}
            </div>

            <div className="view-pdf__button-container">
              <Button
                onClick={() => {
                  onClose();
                  resetForm();
                }}
                className="view-pdf__button"
                variant="outlined"
                color="secondary"
              >
                Cancel
              </Button>
              <SubmitButton handleClick={handleSubmit} buttonText="Download" />
            </div>

            {isSubmitting && (
              <LoadingModal open={isSubmitting} loadingText="Downloading..." />
            )}
          </>
        )}
      </Formik>
    </ModalWrapper>
  );
};

export default LateRPMPatient;
